<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre7"><span id="Page_48" title="[Pg 48]"></span></p>
<h2 class="nobreak" id="CHAPTER_VII">CHAPTER VII<br class="calibre16"/><br class="calibre16"/>
<span class="small">MRS. DAWSON'S DRESSES</span></h2>
</div>
<p class="calibre7"><span class="smcap">The</span> hot weather was in full possession of Ramghur,
and, as a natural consequence, the station became
deserted. Various bragging individuals, who
had announced their determination to "face it this
year," had at the first boom of its artillery—that
fierce midday blast,—closed their bungalows, distributed
their pets and flowers, lent their cows, and
carriages, among their friends, and departed precipitately
to cooler regions. It was a sickly season; already
the bazaar prediction had been more than justified.
Only those whom duty or poverty chained to
the cantonment were to be found at their posts, and
these were to be seen, very late or very early, driving
about the dusty roads, with haggard white faces.</p>
<p class="calibre7">It is a well-established fact, that one hot weather
endured in company draws people more nearly together
than a dozen cold seasons. There is a general
relaxing of stiffness, a putting off of armour, a
reliance on one another, and a liberal exchange of
sympathy—and secrets;—undoubtedly a fellow feeling
makes one wondrous kind. For example, if a
cynic happened to remark what friends two sharply
contrasting ladies had become, "Oh, they spent a hot
weather together in Kalipore," would be accepted as
an unanswerable reply. Moreover, it is undisputed,
that some of the best matrimonial prizes have been
snatched out of the heat of the plains, by maidens

<span id="pgepubid00048" title="[Pg 49]"></span>

who clung to their parents, and braved the consequences.
Thus, they occasionally made the acquaintance
of some bored and solitary bachelor, who,
failing to obtain leave, presently consoled himself
with a wife.</p>
<p class="calibre7">The band of the Native Cavalry,—Mr. Shafto's
Regiment,—played thrice a week in the club gardens,
and then the pale remnant of Europeans (and
many brilliant Eurasians) assembled to what the natives
term "eat the air" and exchange the contents of
letters from the hills, and the delinquencies of their
domestics.</p>
<p class="calibre7">Everywhere beyond the gardens the atmosphere
was that of a brickkiln. Within, among the trees,
shrubs, and glistening foliage plants, the nostrils
were greeted by the smell of hot earth, and a recently
watered greenhouse,—that is an aroma peculiar to
India. In the early morning, immediately after sunrise,
the club was at its best; thronged with members
who came to study the telegrams, glance at the
papers, and pick up any stray crumbs of local news.
It was thus that the youngest Miss Brewer first allured
Mr. Pontefract into conversation on the subject
of "a fire in the Bazaar." Hitherto he had
thought of her (if he ever did think of her) as a
plain, heavy young woman, who could neither ride
nor dance, but just lob over the net at tennis. Now
he discovered, thanks to the hot weather, that she
was a surprisingly taking girl, with a good deal in
her, including brains. She talked well (and shared
his views on the subject of the club soda-water, and
Sunday tennis); moreover, she was a devout listener.</p>
<p class="calibre7"><span id="pgepubid00049" title="[Pg 50]"></span></p>
<p class="calibre7">Between listening and talking, the moments flew;
at last, the increasing heat, and the clamour of the
coppersmith bird, awakened the pair to the fact that
it was seven o'clock, and much too late an hour to
be abroad; and then, as Miss Brewer's pony carriage
boasted a hood, she offered a seat to her new acquaintance,
and enjoyed the pleasure and triumph of
conveying the rising civilian to his own door. She
carried him off in every sense of the word, in fact—she
was a particularly "taking" girl. This drive
was the prelude to greater events—to meetings at
dawn, to walks after dark, to little dinners, little
presents,—and an engagement. Yes, it was quite
true, Tilly Brewer, the unprepossessing, the dowdy,
was about to marry the best <i class="calibre11">parti</i> in Ramghur; and
when the young ladies in the hills heard the tidings,
they each and all registered a mental vow to remain
below next season. It is so easy to make such resolutions
when you are in a perfect climate.</p>
<p class="calibre7">The talk of the engagement created an agreeable
break in the long monotonous days, and mere acquaintances
exhibited quite an affectionate interest
in Tilly's trousseau, presents, and prospects.</p>
<p class="calibre7">However, early in May, another topic cropped up
which entirely eclipsed the marriage preparations,
and afforded food for incessant discussion until the
end of the rains; in fact, the story of "Mrs. Dawson's
dresses" created such an uproar and commotion,
that it got into some of the local papers, and
every one of the letters home.</p>
<p class="calibre7">Mrs. Dawson, the Judge's wife, was a prim, spare
woman of a certain age—and, it was said, uncertain
temper. She had a cool, stiff manner, and an air of

<span id="pgepubid00050" title="[Pg 51]"></span>

critical aloofness that seriously discounted her popularity.
This lady was Mrs. Wilkinson's most serious
rival in the matter of dress, and if her taste was less
artistic, and her ideas lacked courage, she employed
a court milliner, and owned a long purse. It must
be admitted that her toilettes were both varied and
expensive. "Stiff and old-maidish," was Mrs. Wilkinson's
verdict—for she never soared to that lady's
daring transformations, and condemned her dazzling
triumphs as "theatrical and loud." Twice a
year Mrs. Dawson received a large box or two from
home, containing a fashionable outfit for the approaching
season, and the envious pangs the arrival
of these treasures occasioned Mrs. Wilkinson, no
one—no, not even her closest friend—had ever
guessed.</p>
<p class="calibre7">A consignment of costumes had recently arrived
per ss. <i class="calibre11">Arcadia</i>, and Mrs. Dawson invited all her
neighbours to inspect them. The dresses were to be
on view for two succeeding afternoons, but their
owner omitted to despatch a little note to Mrs. Wilkinson.
She would see all the toilettes later on in
public, and, meanwhile, as she might steal some of
the novel ideas, and was quite capable of carrying
away a Paris pattern "in her eye," the poor lady was
cruelly excluded. Late one evening Mrs. Rattray
dropped in on Mrs. Wilkinson, <i class="calibre11">en route</i> from the
exhibition. She was a lively, fair woman, with an
immense stock of superfluous enthusiasm. As soon
as she had found a seat, and unfurled her fan, she
began,</p>
<p class="calibre7">"Well, my dear, I've never seen such frocks as she
has got this time."</p>
<p class="calibre7"><span id="pgepubid00051" title="[Pg 52]"></span></p>
<p class="calibre7">"No," cried her hostess eagerly; "you have been
to the show—do tell me all about them. I am dying
to know what the dresses are like. French, of course—she
said so."</p>
<p class="calibre7">"Yes," drawing a long breath. "There is a grey
<i class="calibre11">crêpe de chine</i> and silver, like the moon in a mist,
with very long, tight sleeves, and a sort of double
skirt—it's a dream. There is a lemon satin with
Egyptian embroidery and a long train, a black silk
canvas with lace sleeves, piece lace—<i class="calibre11">you</i> could easily
copy that; and there is a lovely mauve tea-gown,
with a yoke of point d'Alençon, and knots of black
velvet with long ends, to which I lost my heart—it's
quite my style—but she never lends a pattern, you
know."</p>
<p class="calibre7">"Yes," agreed her listener, "we all know that."</p>
<p class="calibre7">"Then there are hats, and toques, and feathers,
and silk petticoats. I never saw so many pretty
things all at once. I think she got some smart cousin
to choose them, for they are not in the same style as
her usual dresses—really, you won't know her."</p>
<p class="calibre7">Further details, descriptions, and even sketches,
prolonged the interview for more than an hour.
Meanwhile Angel sat growing in a corner, totally
unnoticed, but absorbing every word of the conversation
with a curious expression on her little elfish
face.</p>
<p class="calibre7">"I must say, it is most marked, her not inviting
you," said Mrs. Rattray, as she rose at last. "Several
people noticed it, and Mrs. Gordon was wondering
why you had not come; 'the show was so much
in your line.' Of course, I did not tell her why you
stayed away; at any rate, you will see one of the

<span id="pgepubid00052" title="[Pg 53]"></span>

frocks on Sunday, a white Chinese silk, much too
young for Mrs. Dawson; I'm sure she is long past
forty. Well, good-bye, dear, I knew you'd be dying
to hear all about the exhibition, so I just ran in to
tell you." And then Mrs. Rattray bustled out to her
victoria, leaving her stricken hostess to digest her
news as best she might. Alas! what were two or
three pretty muslins, or even a new lilac foulard,
against Mrs. Dawson's battle array, gowns direct
from Doucet and Rouff? Oh, money must tell in
the end! and, burying her face among her sofa cushions,—for
she was weak and run down,—Mrs. Wilkinson
wept long and bitterly, she who but five minutes
ago had been all animation and smiles.</p>
<p class="calibre7">Two mornings later, Mrs. Rattray encountered
Mrs. Dawson in the club library. Greatly to her surprise,
the latter accosted her at once; for, as a rule,
she merely bestowed a cool nod.</p>
<p class="calibre7">"Have you heard about my dresses?" she began
excitedly.</p>
<p class="calibre7">"But you forget that I have inspected them," said
the other; "I never saw anything half so exquisite,
or so——"</p>
<p class="calibre7">"Exquisite no longer!" broke in Mrs. Dawson
with a catch in her voice; "what do you think? I
had some friends to my little show yesterday, all the
gowns laid out in my bedroom, just as when you
came,—and then we went into the drawing-room to
tea. After they had left, I sent for the ayah, intending
to help her to fold the things, and put them in
tissue paper." Here she paused for breath, and
seemed curiously agitated.</p>
<p class="calibre7">"Why, yes, of course," assented Mrs. Rattray.

<span id="pgepubid00053" title="[Pg 54]"></span>

She stood with her hands on the back of a chair, facing
the narrator, and wondering at her emotion. It
was something novel to see Mrs. Dawson, of all
people, thus mentally dishevelled.</p>
<p class="calibre7">"When I went into my room with a light," she
resumed, "I found that all my beautiful things had
been cut to pieces—into little—little bits!"</p>
<p class="calibre7">"What!" cried Mrs. Rattray, raising her voice till
it was almost a scream.</p>
<p class="calibre7">"Yes, every one of them, and done most systematically—nothing
escaped, not even my poor feather
fan, nor a hat, or a blouse. The ayah kept crying,
'Look, look, look,' till I was sick of looking. Sleeves
were hacked out of dresses, great pieces slashed out
of the bodices, skirts cut right across, in all directions;
even the artificial flowers were torn to pieces,
and the fingers snipped off my evening gloves." She
paused, and there was a dead silence, for Mrs. Rattray
could find no words adequate to the occasion.
She simply stared, with her topee pushed back, from
her forehead, and her lips wide apart.</p>
<p class="calibre7">"And—the grey <i class="calibre11">crêpe</i>?" she stammered out at
last.</p>
<p class="calibre7">"A rag now. The lemon satin only fit for patchwork.
There is not even enough left to make a sofa
cushion. It was all done in about half-an-hour—and
with a huge pair of dirzee's scissors."</p>
<p class="calibre7">"But who did it?" cried her listener, breathlessly.
"Have you no suspicions?"</p>
<p class="calibre7">"No, that is the strange part of it; not a soul was
seen or heard about the premises. All the doors in
the verandah were wide open, the chokedar was on
duty, and he saw no one."</p>
<p class="calibre7"><span id="pgepubid00054" title="[Pg 55]"></span></p>
<p class="calibre7">"Then what does the ayah say?" inquired Mrs.
Rattray judicially.</p>
<p class="calibre7">"Oh, she vows it was an evil spirit, and if she had
not been idling in her godown, but had come in directly
the visitors had left, this frightful affair would
not have happened." Here Mrs. Dawson's voice became
husky; however, she soon recovered her self-possession,
and continued, "Nothing was taken—no,
not even an inch of ribbon—everything is there. So
it was no thief. My husband will have it that it was
Captain Moore's monkey."</p>
<p class="calibre7">Mrs. Rattray drew a long breath. At last she
inquired, with studied deliberation:</p>
<p class="calibre7">"And what is your own opinion?"</p>
<p class="calibre7">"I believe it was the work of some one who knew
more about clothes than a dumb animal," responded
the victim of the outrage; "and yet, it is like a
monkey's trick, so unnecessary, and so mischievous."</p>
<p class="calibre7">"So wicked, I call it," cried Mrs. Rattray. "I
must say you are bearing it marvellously well. It is
more than I could do. I have no fortitude."</p>
<p class="calibre7">"What is the good of worrying? The thing is
done; no amount of worrying will restore my pretty
frocks, and I cannot afford to replace them for some
time; that lemon satin cost forty guineas, and I'd be
ashamed to tell you what I paid for the lilac tea-gown."</p>
<p class="calibre7">"You have no clue?" reiterated Mrs. Rattray.</p>
<p class="calibre7">"Unfortunately, I have not even that small consolation.
Monkey or demon, it left no trace. Well
now, I must be going—the sun is getting so strong I
have a dreadful headache as it is."</p>
<p class="calibre7"><span id="pgepubid00055" title="[Pg 56]"></span></p>
<p class="calibre7">And Mrs. Dawson went sadly down the steps,
crawled into her carriage, and was driven away.</p>
<p class="calibre7">But Mrs. Rattray lingered yet awhile, despite the
temperature, in order to discuss the tragedy with
Mrs. Jones. Ere they separated, she said, "How
pleased Mrs. Wilkinson will be! She will have it all
her own way now."</p>
<p class="calibre7">"Yes," assented her companion, "she lives to
dress, and dresses to live—it is only her clothes that
hold her to earth. She is a mere shadow. Don't
you think she looks frightfully ill, and that it is disgraceful
that Colonel Wilkinson has kept her and the
children down for three hot weathers? I declare it is
next door to murder, and if she dies he ought to be
hanged."</p>
<p class="calibre7">"She wants a change badly," admitted Mrs. Rattray,
"but this news will act as a restorer, equal to
two months' hill air."</p>
<p class="calibre7">"Colonel Wilkinson is a shameless screw," resumed
the other; "everyone knows that he puts away
half his pay monthly, that he never subscribes to
anything—'poverty and a large family' his cry—and
that poor Mrs. Wilkinson finds it almost impossible
to get him to give her a twenty-rupee dress."</p>
<p class="calibre7">"I think Mrs. Dawson might have asked her to her
show; leaving one out is always so pointed."</p>
<p class="calibre7">"But it was intended to be pointed. Mrs. Dawson
was so afraid of having her gowns copied," pleaded
her friend.</p>
<p class="calibre7">"Not much to copy now, is there?" retorted Mrs.
Rattray; "and is it not strange that they have no
suspicions, and no clue?"</p>
<p class="calibre7">"No, neither the one nor the other," rejoined Mrs.

<span id="pgepubid00056" title="[Pg 57]"></span>

Jones, shaking her head solemnly. But Mrs. Jones
was mistaken; there <i class="calibre11">was</i> a clue had Mrs. Wilkinson's
ayah suffered it to pass from her hands.</p>
<p class="calibre7">For one whole morning the dirzee's scissors were
nowhere to be found, and a dirzee, minus his scissors,
is as a dragon without his horse.</p>
<p class="calibre7">Kadir Bux called upon all his gods to witness that
he had left them in his basket the previous day.
Who, then, had taken them? At last, after much
loud talk, and an exhaustive search, the scissors were
discovered under a fashion book in the drawing-room,
and, behold! there was a tiny scrap of lemon
satin stuck fast between the blades.</p>
<p class="calibre7">Then the ayah, who had unearthed them, looked
Angel straight in the eyes, and cried, "O child of the
devil!"</p>
<p class="calibre7">But she put the tell-tale scrap into the cook-house
fire,—and held her tongue.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?52080868